var React = require('react');

function Iphone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".icon-line--style{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}")),React.createElement("title",{"key":1},"Asset 19"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_3","data-name":"Layer 3"},[React.createElement("rect",{"className":"icon-line--style","x":"2","y":"2","width":"44.65","height":"84.95","rx":"4.51","key":0}),React.createElement("line",{"className":"icon-line--style","x1":"2.05","y1":"11.67","x2":"46.6","y2":"11.67","key":1}),React.createElement("line",{"className":"icon-line--style","x1":"2.05","y1":"68.98","x2":"46.6","y2":"68.98","key":2}),React.createElement("circle",{"className":"icon-line--style","cx":"24.33","cy":"77.88","r":"3.15","key":3})]))]);
}

Iphone.defaultProps = {"viewBox":"0 0 48.65 88.95"};

module.exports = Iphone;

Iphone.default = Iphone;
